<mat-card class="mat-card-management">
  <div class="management">
    <div class="list-header app-toolbar">
      <div class="list-header__title-block">
        <div class="list-header__title">
          <b>{{ headerTitle }}</b>
          <app-info-panel-trigger [data]="infoPanelData"></app-info-panel-trigger>
        </div>
        <div class="list-header__subtitle" *ngIf="headerSubtitle">{{ headerSubtitle }}</div>
        <div class="list-header__count" *ngIf="subtitle">{{ subtitle }}</div>
      </div>
      <div class="list-header__actions" *ngIf="tableActions?.length">
        <ng-container *ngFor="let action of tableActions">
          <button
            (click)="action.execute()"
            class="list-action-btn"
            [matTooltip]="action.title"
          >
            <mat-icon>{{ action.icon }}</mat-icon>
            <span>{{ action.title }}</span>
          </button>
        </ng-container>
      </div>
    </div>

    <ng-content select="[management-filter]"></ng-content>

    <div class="management__table">
      <div class="management__table-content">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          [matSortDisableClear]="matSortDisableClear"
          [matSortActive]="defaultSort?.column"
          [matSortDirection]="defaultSort?.direction"
        >
          <ng-content select="[management-column]"></ng-content>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr
            class="management__table-row"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
          ></tr>
        </table>
      </div>

      <div class="management__table-info empty-state" *ngIf="showEmptyState">
        <ng-content select="[management-empty]"></ng-content>
      </div>
    </div>
  </div>
</mat-card>
